var _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _line, _circle, _circle2, _circle3, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _line2, _line3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1170,
    height: 411,
    viewBox: "0 0 1170 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_20_12543)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 2,
    transform: "matrix(-1 0 0 1 885 399)",
    fill: "url(#paint0_linear_20_12543)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_20_12543)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 2,
    transform: "matrix(-1 0 0 1 885 399)",
    fill: "url(#paint1_linear_20_12543)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 277,
    width: 1170,
    height: 123,
    fill: "#030014"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 970,
    height: 393,
    rx: 20,
    fill: "url(#paint2_linear_20_12543)",
    fillOpacity: 0.03
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 0.5,
    width: 969,
    height: 392,
    rx: 19.5,
    stroke: "url(#paint3_linear_20_12543)",
    strokeOpacity: 0.08
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 10,
    width: 950,
    height: 391,
    rx: 12,
    fill: "url(#paint4_linear_20_12543)",
    fillOpacity: 0.04
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 10.5,
    width: 949,
    height: 390,
    rx: 11.5,
    stroke: "url(#paint5_linear_20_12543)",
    strokeOpacity: 0.12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 310.5,
    y1: 10,
    x2: 310.5,
    y2: 401,
    stroke: "url(#paint6_linear_20_12543)",
    strokeOpacity: 0.12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 36,
    r: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 36,
    r: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 36,
    r: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 84,
    width: 160,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 66,
    width: 160,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 84,
    width: 128,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 102,
    width: 99,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 66,
    width: 71,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 84,
    width: 57,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 102,
    width: 45,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 621,
    y: 66,
    width: 110,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 571,
    y: 84,
    width: 88,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 102,
    width: 68,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 66,
    width: 40,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 84,
    width: 32,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 102,
    width: 25,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 791,
    y: 66,
    width: 78,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 707,
    y: 84,
    width: 63,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 631,
    y: 102,
    width: 49,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 135,
    width: 160,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 153,
    width: 128,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 135,
    width: 71,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 153,
    width: 70,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 621,
    y: 135,
    width: 79,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 153,
    width: 108,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 708,
    y: 135,
    width: 28,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 153,
    width: 40,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 135,
    width: 56,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 753,
    y: 153,
    width: 78,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.07
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 186,
    width: 160,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 204,
    width: 128,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 186,
    width: 71,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 204,
    width: 57,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 621,
    y: 186,
    width: 110,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 571,
    y: 204,
    width: 88,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 186,
    width: 40,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 204,
    width: 32,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 791,
    y: 186,
    width: 78,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 707,
    y: 204,
    width: 63,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 237,
    width: 160,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 255,
    width: 128,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 237,
    width: 71,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 255,
    width: 57,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 621,
    y: 237,
    width: 110,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 571,
    y: 255,
    width: 88,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 237,
    width: 40,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 255,
    width: 32,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 791,
    y: 237,
    width: 78,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 707,
    y: 255,
    width: 63,
    height: 8,
    rx: 4,
    fill: "white",
    fillOpacity: 0.01
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 126,
    width: 160,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 168,
    width: 160,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.06
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 210,
    width: 160,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.04
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 252,
    width: 160,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.02
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 294,
    width: 160,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.01
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 336,
    width: 160,
    height: 30,
    rx: 8,
    fill: "url(#paint7_linear_20_12543)",
    fillOpacity: 0.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 59.5,
    x2: 310,
    y2: 59.5,
    stroke: "white",
    strokeOpacity: 0.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 399.5,
    x2: 1170,
    y2: 399.5,
    stroke: "url(#paint8_linear_20_12543)",
    strokeOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_20_12543",
    x: 275,
    y: 389,
    width: 620,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_20_12543"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_20_12543",
    x: 284,
    y: 398,
    width: 602,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_20_12543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_12543",
    x1: 596.25,
    y1: 1.76087,
    x2: 596.156,
    y2: 9.22991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#701EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#CBB3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#030014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_12543",
    x1: 596.25,
    y1: 1.76087,
    x2: 596.156,
    y2: 9.22991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#701EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#CBB3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#030014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_12543",
    x1: 585,
    y1: 0,
    x2: 585,
    y2: 393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_12543",
    x1: 585,
    y1: 0,
    x2: 585,
    y2: 411.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_12543",
    x1: 585,
    y1: 10,
    x2: 585,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20_12543",
    x1: 585,
    y1: 10,
    x2: 585,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20_12543",
    x1: 310,
    y1: 401,
    x2: 310,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20_12543",
    x1: 210,
    y1: 336,
    x2: 210,
    y2: 366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_20_12543",
    x1: 1170,
    y1: 400,
    x2: 0,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.0f25caeca5d5beee4447631142f87872.svg";
export { ForwardRef as ReactComponent };